import React, { useState, useMemo, useEffect } from "react";
import { DatePicker, Input, Select, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import Table from "../components/Table";
import { useFetchReportAdminInputs } from "../hooks/useFetch";
// import { useFetchCase3 } from "../hooks/useFetch";
const { Option } = Select;
const { RangePicker } = DatePicker;

const ReportAdminInputsPage = () => {
  const { mutateAsync: listReportAdminInputs, isLoading } = useFetchReportAdminInputs();
  const [selectedDate, setSelectedDate] = useState([
    dayjs().startOf("month"),
    dayjs().endOf("month"),
  ]);
  const [status, setStatus] = useState("waiting");
  const [data, setData] = useState([]);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePaginationChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
    // handleSearch();
  };

  const buttonSearch = () => {
    setPage(1);
    setPageSize(10);
    handleSearch();
  }

  const handleSearch = async () => {
    const res = await listReportAdminInputs({
      start_date: selectedDate[0].format("YYYY-MM-DD"),
      end_date: selectedDate[1].format("YYYY-MM-DD"),
      // page,
      // pageSize,
      // status,
    });
    setData(res || []);
  };

  useEffect(() => {
    handleSearch();
  }, []);
  
  return (
    <div style={{ padding: 16, background: "#f5f5f5", minHeight: "100vh" }}>
      {/* Title */}
      <div style={{ marginBottom: 20 }}>
        <h1
          style={{
            margin: 0,
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#212121",
            letterSpacing: "0.5px",
            lineHeight: 1.2,
          }}
        >
          Report การทำงาน
        </h1>
      </div>


      {/* Filter Section */}
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: 20,
          marginBottom: 20,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: 16,
            alignItems: "end",
          }}
        >
          <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              วันที่
            </label>
            <RangePicker
              value={selectedDate}
              onChange={setSelectedDate}
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              allowClear={false}
            />
          </div>

          {/* <div>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              ประเภท
            </label>
            <Select
              value={status}
              onChange={setStatus}
              placeholder="เลือกประเภท"
              allowClear
              style={{ width: "100%" }}
            >
              <Option value="pass">Pass</Option>
              <Option value="waiting">Waiting</Option>
              <Option value="fail">Fail</Option>
            </Select>
          </div> */}
          <div>
            <Button
              type="primary"
              onClick={handleSearch}
              style={{
                width: "100%",
                height: "32px",
              }}
            >
              ค้นหา
            </Button>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <Table
        data={data?.data || []}
        loading={isLoading}
        handleSearch={buttonSearch}
        pagination={{
          current: page,
          pageSize: pageSize,
          total: data?.count || 0,
        }}
        onPaginationChange={handlePaginationChange}
      />
    </div>
  );
};

export default ReportAdminInputsPage;

